import { render, staticRenderFns } from "./AllOrgPerson.vue?vue&type=template&id=6e9f5c9d&scoped=true&"
import script from "./AllOrgPerson.vue?vue&type=script&lang=js&"
export * from "./AllOrgPerson.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/zan.css?vue&type=style&index=0&id=6e9f5c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f5c9d",
  null
  
)

export default component.exports